<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <div>
        <v-toolbar dense class="mb-2 indigo white--text" flat>
            <v-toolbar-title>Export Type</v-toolbar-title>
        </v-toolbar>
        <v-row dense>
            <v-col>
                <v-radio-group v-model="currentUserChanges.preferences.exportType" row>
                    <v-radio label="ALL" value="ALL" color="black"/>
                    <v-radio label="CSV" value="CSV" color="black"/>
                    <v-radio label="PDF" value="PDF" color="black"/>
                </v-radio-group>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    export default
    {
        name: 'export-type',
        computed:
        {
            ...mapState('auth',
            {
                currentUserChanges: state => state.currentUserChanges ? state.currentUserChanges : {preferences: {}}
            })
        }
    };
</script>

<style scoped>
</style>